export const USER_FEATURES_KEYS = {
  phoneOnlyAccounts: 'phoneOnlyUsers',
  technicalUsers: 'technicalUsers',
  transactions: 'transactions',
} as const;
